import services from '@/config/services'

export default class ClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.basePraticheUrl = `${services.ask_pratiche.url}`
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/clienti/rappresentanti/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'codfis',
        label: 'Codice Fiscale',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        default: true,
      },
      {
        property: 'name',
        label: 'Nome Cognome',
        sortable: true,
        default: true,
      },
      {
        property: 'provincia',
        label: 'Provincia',
        sortable: true,
        default: true,
      },
      {
        property: 'comune',
        label: 'Comune',
        sortable: true,
        default: true,
      },
      {
        property: "indirizzo",
        label: "Indirizzo",
        default: true,
      },
      {
        property: "civico",
        label: "Civico",
        default: true,
      },
      {
        property: "tel",
        label: "Telefono",
        default: true,
      },
      {
        property: "cell",
        label: "Cellulare",
        default: true,
      },
      {
        property: "email",
        label: "Email",
        default: true,
      },
      {
        property: "pec",
        label: "PEC",
        default: true,
      },
    ]
  }

  async getDettaglioRappresentante(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/rappresentanti/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false
    let error = null

    const url = `${this.baseUrl}/clienti/rappresentanti/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
      error = res.meta.validate?.codfis?.[0] || null
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      error = 'Impossibile aggiornare il rappresentante.'
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success,
        error
      }
    }
  }


  async getProspettoCicloPagamenti(id, year){
    let item = {}

    const url = `${this.baseUrl}/clienti/rappresentanti/${id}/prospetto-ciclo-pagamenti/${year}`
    try {
      let res = await this.http.get(url)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getDetailsInfoRappresentante(idRappresentante, page = 1, pageSize = 15){
    let items = []
    let pagination = null

    const url = `${this.baseUrl}/clienti/rappresentanti/${idRappresentante}/details-info`
    try {
      let res = await this.http.get(url, {
        params: {
          page: page,
          page_size: pageSize
        }
      })
      res = res.data
      items = res.data || []
      
      if (res.meta && res.meta.pagination) {
        pagination = res.meta.pagination
      } else if (res.pagination) {
        pagination = res.pagination
      } else if (res.current_page !== undefined) {
        pagination = {
          current_page: res.current_page,
          per_page: res.per_page,
          total: res.total
        }
      } else if (res.meta) {
        pagination = {
          current_page: res.meta.current_page,
          per_page: res.meta.per_page,
          total: res.meta.total
        }
      }

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        pagination
      }
    }
  }

  async addNewContact(contact, idRapp){

    const url = `${this.baseUrl}/clienti/rappresentanti/contact/create`
    try {
      let res = await this.http.post(url, {contact, idRapp})

      this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')

    }
  }

  async updateContact(contact, idRapp){

    const url = `${this.baseUrl}/clienti/rappresentanti/contact/update`
    try {
      let res = await this.http.post(url, {contact, idRapp})
      if (res.data.success) {
        this.eventBus.emit('data-load-success', {message: res.data.msg})
        return true
      }
      this.eventBus.emit('data-load-error', {message: res.data.msg || 'Modifica del contatto non salvata', url})
      return false
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return false
    } finally {
      this.eventBus.emit('data-loaded')

    }
  }

  async getSummaryProvvigioniRappresentante(rappresentanteId, typeView, typeGroup, years){
    let items = {}

    const url = `${this.basePraticheUrl}/provvigioni/riepilogo/rappresentante`
    try {
      let res = await this.http.post(url, {
        rappresentanteId,
        typeView,
        typeGroup,
        years
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }


}
